import { gql } from '@apollo/client';

export default class DocumentsQuery {
    static GET_DOCUMENT_SECURE_URL = gql`
        query getDocumentSecureURL($path: String!) {
            getDocumentSecureURL(path: $path)
        }
    `;
}
